import { Tab } from '@reach/tabs';

import useStyles from './styles';
import ITabButton from './types';

import '@reach/tabs/styles.css';

function TabButton({ children, disabled, index }: ITabButton) {
  const classes = useStyles();

  return (
    <Tab disabled={disabled} index={index} className={classes.root}>
      {children}
    </Tab>
  );
}

export default TabButton;
